import { gateway } from '../utils/api';

export const handleCpfConsultation = async (cpf, documentType) => {
  try {
    const idProfile = localStorage.getItem('idProfile');
    const url = `/webbff/lit_app_web/profile/cpf/${cpf}/${idProfile}/${documentType}`;
    await gateway.get(url);
  } catch (error) {
    throw error;
  }
};
